module.exports = __webpack_public_path__ + "static/media/saas-advantage-icon-4.e7240d61.png";